import React from 'react'
import Select from 'react-select';


export default class SelectBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = { selectedOption: '' };
    }


    handleChange = (selectedOption) => {
        this.setState({ selectedOption });
        this.props.handleChange && this.props.handleChange(selectedOption && selectedOption.value)
        // console.log(`Selected: ${selectedOption.label}`);
    }

    render() {
        const { selectedOption } = this.state;
        const value = selectedOption && selectedOption.value;

        return (
            <Select
                name={this.props.selectName}
                value={value || this.props.selectedOption}
                onChange={this.handleChange}
                options={this.props.carModels}
                placeholder={this.props.placeholder}
            />
        );
    }
}